import { Tables } from "@/lib/supabase/supabase_types_override";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";

export function useGetCrmById(crmId?: Tables<'crm'>['id']) {
    return useQuery({
        ...queryKeys.crm.details(crmId!),
        enabled: !!crmId
    });
}